// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsNo6C1vkQ5ZKj {
  width: 511px;
  height: 40px;
  margin-bottom: var(--ds-space-0, 0px);
  font-size: 35px;
  font-weight: var(--ds-font-weight-bold, bold);
  white-space: nowrap;
}
@media only screen and (max-width: 750px) {
  .lsNo6C1vkQ5ZKj {
    width: 90%;
    height: 100%;
    white-space: normal;
  }
}
.odkW3awQ0tM5Hw {
  width: 511px;
  height: 40px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding-bottom: 30px;
  font-size: 14px;
  line-height: 20px;
}
@media only screen and (max-width: 750px) {
  .odkW3awQ0tM5Hw {
    width: 90%;
    height: 100%;
    padding-top: var(--ds-space-150, 10px);
  }
}
.d37e9haxXTfVWt {
  z-index: 0;
  width: 400px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding-top: 150px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding-left: 20%;
}
@media only screen and (max-width: 750px) {
  .d37e9haxXTfVWt {
    width: 95%;
    /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
    padding-left: 46px;
  }
}
._NIfxkJaBExOvE {
  padding: var(--ds-space-150, 10px) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
@media only screen and (max-width: 750px) {
  ._NIfxkJaBExOvE {
    padding: var(--ds-space-150, 10px) var(--ds-space-500, 40px) var(--ds-space-0, 0) var(--ds-space-0, 0);
    text-align: left;
  }
}
.hYXToTj4ypw4l6 {
  width: 100%;
}
@media only screen and (max-width: 750px) {
  .Ub3Pu4xjjk4mXS {
    margin-right: var(--ds-space-500, 40px);
  }
}
.XMdJzxMSfmhPF3 {
  margin-top: var(--ds-space-200, 15px);
}
.XMdJzxMSfmhPF3 p {
  padding-bottom: var(--ds-space-150, 10px);
}
`, ""]);
// Exports
export var title = `lsNo6C1vkQ5ZKj`;
export var subtitle = `odkW3awQ0tM5Hw`;
export var body = `d37e9haxXTfVWt`;
export var loggedOutPageLoginButton = `_NIfxkJaBExOvE`;
export var loggedOutPageSignupButtonWrapper = `hYXToTj4ypw4l6`;
export var loggedOutPageSignupButton = `Ub3Pu4xjjk4mXS`;
export var requestStorageAccessWrapper = `XMdJzxMSfmhPF3`;
export default ___CSS_LOADER_EXPORT___;
